import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-gateways',
  templateUrl: './payments-gateways.component.html',
  styleUrls: ['./payments-gateways.component.scss']
})
export class PaymentsGatewaysComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
